import { Link } from 'react-router-dom';
import './NavCard.css';
import NavCardBadge from './NavCardBadge';

export function NavCard({showBadge, number, children, cardName, navCardLink, hasText, heading}) {
  return (
    <div className='nav_card'>
      <Link to={navCardLink}>
        <div className='nav_card_container'>
        <div className="project_nav_card">
            {
              showBadge && (number > 0) &&
              <NavCardBadge number={number} />
            }
            {children}
          </div>
            {hasText && <h1>{heading}</h1>}
            <p className='nav_card_name'>{cardName}</p>
        </div>
      </Link>  
    </div>
  )
}
